'use client';

import { GoogleTagManager } from '@next/third-parties/google';
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { gtmPageView } from '@/libs/gtm';

// Create a separate component for the analytics tracking logic
function AnalyticsTracking() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const pagePath = `${pathname}${searchParams?.toString() ? `?${searchParams.toString()}` : ''}`;
    const props = {
      page_title: pagePath || null,
    };
    gtmPageView(props);
  }, [pathname, searchParams]);

  return null;
}

// Main component wrapped with Suspense
export function Analytics() {
  if (process.env.NODE_ENV !== 'production') {
    return null;
  }

  return (
    <>
      <Suspense fallback={null}>
        <AnalyticsTracking />
      </Suspense>
      <GoogleTagManager gtmId="GTM-WHKZB8BB" />
    </>
  );
}
